<template>
    <v-container fluid>
        <v-layout>
            <v-flex class="text-center">
                <h2>Rondas Abiertas</h2>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex class="text-center">
                <v-btn color="info" block @click="$router.go(-1)">Devolverse</v-btn>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <!-- Rondas abiertas -->
                <v-card v-for="item in openRounds" :key="item.id" class="mt-2">
                    <v-card-title
                        ><h4>Ronda: {{ item.round.name }}</h4></v-card-title
                    >
                    <v-card-text>
                        <v-layout>
                            <v-flex xs12>ID: {{ item.id }}</v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12>Cliente: {{ item.client.name }}</v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12>Sede: {{ item.round.venue_name }}</v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12>Puesto: {{ item.round.service_spot_name }}</v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12>Checklist: {{ item.round.check_list.length }}</v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12
                                >Puntos de control: {{ item.round.control_points.length }}</v-flex
                            >
                        </v-layout>
                        <v-layout>
                            <v-flex xs12>
                                <v-alert :value="true" color="warning" icon="priority_high" outline>
                                    Inicio: {{ item.startDate | datetime }}
                                </v-alert>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" block @click="continueRound(item)"
                            >Continuar Ronda</v-btn
                        >
                        <v-dialog v-model="dialog">
                            <template v-slot:activator="{ on }">
                                <v-btn color="error" v-on="on">Cerrar Ronda</v-btn>
                            </template>
                            <v-card>
                                <v-card-title>Justificación</v-card-title>
                                <v-card-text>
                                    <v-textarea autofocus v-model="notes"></v-textarea>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="default" @click="dialog = false">Cancelar</v-btn>
                                    <v-btn color="error" @click="closeRound(item)">Confirmar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
    data: () => ({
        selectedRound: null,
        dialog: false,
        notes: '',
    }),
    computed: {
        ...mapGetters(['openRounds']),
    },
    methods: {
        ...mapActions(['loadOpenRounds']),
        ...mapMutations({
            setCurrentRound: 'currentRound',
            setRoundInProgress: 'roundInProgress',
            setOpenRounds: 'setOpenRounds',
            setClient: 'client',
        }),
        async closeRound(round) {
            if (!this.notes) return toastr.error('Debe especificar una justificación')

            const { data } = await this.$repo.post(`rounds/instances/${round.id}/close`, {
                notes: this.notes,
            })
            if (!data) return toastr.error('Ocurrió un error al cerrar la ronda')

            this.loadOpenRounds()
            this.notes = ''
            this.dialog = false
        },
        continueRound(round) {
            const roundInProgress = _.cloneDeep(round)
            delete roundInProgress['round']
            const theRound = _.cloneDeep(round.round)
            const client = _.cloneDeep(round.client)
            this.setClient(client)
            this.setCurrentRound(theRound)
            this.setRoundInProgress(roundInProgress)
            this.$router.push({ name: 'roundInProgress' })
        },
    },
}
</script>
